<template>
    <footer id="footer-cont">
        <div class="top">
            <div class="content">
                <div class="left inline-block vertical-align-top">
                    <div class="logo"></div>
                    <div class="ask" v-html="askHtml"></div>
                    <!-- <button-el v-on:click.native="modal.showModal = true" button-text="Бесплатная консультация" button-class="yellow big"></button-el> -->
                    <request-button :button-class="'yellow big'" :buttonText="'Бесплатная консультация'"/>
                </div>
                <div class="right inline-block vertical-align-top">
                    <div class="contacts">
                        <div class="heading">Контакты</div>
                        <div class="phone">{{ $store.state.data.phone }}</div>
                        <div class="email">{{ $store.state.data.email }}</div>
                        <div class="address">{{ $store.state.data.adress }}</div>
                    </div>
                    <div class="products">
                        <!-- <div class="heading">Умный Дом</div> REL-->
                        <div class="heading"></div>
                        <div>
                            <router-link v-for="product in products" :key="product.id" :to="product.path" v-html="product.name"></router-link>
                        </div>
                    </div>
                    <div class="menu">
                        <router-link v-for="item in menuItems" :key="item.id" :to="item.path" v-html="item.name"></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="content">
                <!-- Copyright © 2016-{{new Date().getFullYear()}} Сибирь Телематика | <a href="javascript:void(0)">Пользовательское соглашение</a> REL-->
                Copyright © 2016-{{new Date().getFullYear()}} Сибирь Телематика　|　Информация на сайте носит справочный характер и ни при каких условиях не является публичной офертой
            </div>
        </div>
        <modal
                v-if="modal.showModal"
                v-on:submit="modal.showModal = false; requestDone.showModal = true"
                v-bind:width="modal.width"
                v-bind:height="modal.height"
                v-bind:buttonText="modal.buttonText"
                v-bind:buttonClass="modal.buttonClass"
                v-bind:header="modal.header"
                v-bind:body="modal.body"
                v-bind:footer="modal.footer"
                @close="modal.showModal = false">
        </modal>
        <modal
                v-if="requestDone.showModal"
                v-on:submit="requestDone.showModal = false"
                v-bind:width="requestDone.width"
                v-bind:height="requestDone.height"
                v-bind:buttonText="requestDone.buttonText"
                v-bind:buttonClass="requestDone.buttonClass"
                v-bind:header="requestDone.header"
                v-bind:body="requestDone.body"
                v-bind:footer="requestDone.footer"
                @close="requestDone.showModal = false">
        </modal>
    </footer>
</template>

<script>
    import ButtonEl from './elements/ButtonEl.vue'
    import Modal from './Modal.vue'
    import RequestButton from '@/views/main/RequestButton.vue'

    const modalBody = [
        '<p>Введи свой номер телефона/Email</p>',
        '<form>',
        '<input type="text" name="request[phone]" placeholder="Телефон/Email">',
        '<input type="checkbox" id="privacy-policy" name="request[policy]">',
        '</form>'
    ].join('')

    const requestDone = [
        '<p>Введи свой номер телефона/Email</p>'
    ].join('')

    export default {
        data() {
            return {
                askHtml: 'Появился вопрос?<br />Задайте нашим специалистам',
                products: [
                    // {path: '/products/water', name: 'Учет воды'},
                    // {path: '/products/electro', name: 'Учет электроэнергии'},
                    // {path: '/products/heat', name: 'Учет тепла'},
                    // {path: '/products/sensor', name: 'Умные датчики'}
                ],
                menuItems: [
                    // {path: '/tariffs', name: 'Тарифы'},
                    {path: '/pnd', name: 'Согласие на обработку персональных данных'},
                    {path: '/reglament', name: 'Регламент использования программного комплекса i868.ru'},
                ],
                modal: {
                    showModal: false,
                    width: '685px',
                    height: '565px',
                    header: 'Получите консультацию<br />прямо сейчас',
                    body: modalBody,
                    buttonText: 'Отправить заявку',
                    buttonClass: 'big yellow no-float'
                },
                requestDone: {
                    showModal: false,
                    width: '685px',
                    height: '380px',
                    header: '<span class="green">Мы получили вашу заявку</span>',
                    body: requestDone,
                    buttonText: 'Понятно',
                    buttonClass: 'big white no-float'
                },
            }
        },
        components: {
            ButtonEl,
            Modal,
            RequestButton
        }
    }
</script>

<style>
    #footer-cont .top .left  a {
        padding: 14px 25px;
    }
</style>
<style scoped>
    @media screen and (max-width: 1366px) {
        .top .content .left {
            width: 30%
        }

        .top .right {
            width: 69%
        }

        .top .right > div {
            width: auto;
            min-width: 160px;
        }
    }

    @media screen and (max-width: 992px) {
        .top {
            position: relative;
        }

        .top .content {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column-reverse;
        }

        .top .content .left {
            width: 100%;
            text-align: center;
            border-top: solid 1px #4c4c4c;
            margin-top: 30px;
        }

        .top .content .left > div {
            margin: 0 auto;
        }

        .top .content .left .logo {
            display: none;
        }

        .top .right {
            width: 100%;
            margin-bottom: 30px;
        }

        footer .bottom {
            padding: 13px 0;
        }

        .top .content .right > div {
            margin-bottom: 30px;
        }

        .ask {
            margin: 30px 0;
        }

        .top .left a.yellow {
            float: none;
            display: inline-block;
            margin: 15px auto;
        }
    }

    footer {
        background: #CCC;
    }

    .top {
        background: #313131;
        min-height: 298px;
    }


    .top .left {
        width: 393px;
        padding: 40px 0;
    }

    .ask {
        color: #FFFFFF;
        margin-top: 32px;
        font-size: 17px;
        font-weight: 500;
        margin-bottom: 14px;
    }

    .bottom {
        background: #212020;
        font-size: 12px;
        color: #b1b1b1;
        padding: 13px 0;
        font-weight: 300;
    }

    .bottom a {
        color: #b1b1b1;
    }

    .left > button {
        padding: 14px 25px;
    }

    .right {
        padding-top: 48px;
    }

    .right > div:first-child {
        width: 315px;
        min-height: 40px;
    }

    .right > div {
        width: 215px;
        min-height: 40px;
        display: inline-block;
        vertical-align: top;
        font-size: 17px;
        font-weight: 300;
        color: #FFF;
    }

    .phone,
    .email {
        margin-top: 20px;
        margin-left: 33px;
        font-weight: 700;
        position: relative;
    }

    .phone {
        margin-top: 20px;
    }

    .email {
        margin-top: 13px;
    }

    .address {
        margin-top: 30px;
        font-size: 14px;
        color: #b1b1b1;
        width: 277px;
    }

    .phone:before {
        content: '';
        width: 24px;
        left: -34px;
        top: -3px;
        height: 24px;
        position: absolute;
        background: url('../assets/images/phone.svg') center no-repeat;
    }

    .email:before {
        content: '';
        width: 24px;
        left: -34px;
        top: -3px;
        height: 24px;
        position: absolute;
        background: url('../assets/images/email.svg') center no-repeat;
    }

    .products div a {
        display: block;
        color: #b1b1b1;
        font-size: 14px;
        margin-top: 12px;
    }
    
    .menu a {
        display: block;
        color: #FFFFFF;
    }

    .menu a:not(:first-child) {
        margin-top: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Footer.vue